import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, InternalAxiosRequestConfig } from 'axios';

interface CustomAxiosConfig extends AxiosRequestConfig {
  authToken?: string;
}

const createHttpClient = (config?: CustomAxiosConfig): AxiosInstance => {
  const client = axios.create(config);

  client.interceptors.request.use(
    (requestConfig: InternalAxiosRequestConfig) => {
      if (config?.authToken) {
        requestConfig.headers['Content-Type'] = 'application/json';
        requestConfig.headers['Authorization'] = `Bearer ${config.authToken}`;
      }
      return requestConfig;
    },
    (error: AxiosError) => Promise.reject(error)
  );

  client.interceptors.response.use(
    (response: AxiosResponse) => response,
    (error: AxiosError) => Promise.reject(error)
  );

  return client;
};

export default createHttpClient;
